import { ElementMenuItem } from './elementMenuItem';
import { SlotElement } from './slotElement';
import Element, { ElementType, SpecyficType } from './element';
import { Vector2 } from '@babylonjs/core';
import { placementManager } from './placementManager';
import { BaseShape } from './IShape';

class InnerSlotsManager {
    private elements!: Element[];
    private slots!: SlotElement[];

    private get body(): Element {
        return this.elements.find((x) => x.type === ElementType.BODY)!;
    }

    public initialize(elements: Element[], slots: SlotElement[]) {
        this.elements = elements;
        this.slots = slots;
    }

    public createSlots(element: ElementMenuItem): SlotElement[] {
        if (element.specyficType === SpecyficType.SHELF) {
            const offsetY = 0.5 * element.shape.y;
            return this._createSlots(element, offsetY, 0.5);
        } else {
            const offsetY = 0.5 * (element.shape.y - 1);
            return this._createSlots(element, offsetY, 1);
        }
    }

    private _createSlots(
        element: ElementMenuItem,
        offsetY: number,
        jIncrement: number): SlotElement[] {
        const result: SlotElement[] = [];
        const offsetX = 0.5 * (element.shape.x - 1);
        const slots = element.specyficType === SpecyficType.SHELF ?
            this.slots.filter((x) => x.shelfSlot) :
            this.slots.filter((x) => !x.shelfSlot);
        for (let i = 1 + offsetX; i <= this.body.shape.x - offsetX; i++) {
            for (let j = 1 + offsetY; j <= this.body.shape.y - offsetY; j += jIncrement) {
                if (this.isNotAllowed(element, i, j)) { continue; }
                const position = new Vector2(i, j);
                if (placementManager.canPlace(position, element.shape, element.type, element.specyficType)) {
                    const test = new BaseShape(position, element.shape);
                    result.push(...slots.filter((x) => x.inside(test)));
                }
            }
        }
        return result;
    }

    private isNotAllowed(element: ElementMenuItem, i: number, j: number): boolean {
        if (element.specyficType === SpecyficType.DRAWER && j > 2) {
            // ograniczenie wysokościowe szuflad
            return true;
        }
        return false;
    }
}

export const innerSlotsManager = new InnerSlotsManager();
